
import React from 'react';
import Logo from './Logo';

interface AuthLayoutProps {
  children: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen w-full flex flex-row">
      {/* Left Side - Content */}
      <div className="w-full lg:w-1/2 flex flex-col justify-center items-center bg-white p-8 lg:min-h-screen z-10">
        <div className="w-full max-w-md">
          {children}
        </div>
      </div>

      {/* Right Side - Branding */}
      <div className="hidden lg:flex w-full lg:w-1/2 bg-slate-50 relative items-center justify-center border-l border-gray-100">
         <div className="text-center">
             <div className="flex justify-center">
                 <Logo size="lg" />
             </div>
         </div>
      </div>
    </div>
  );
};

export default AuthLayout;
